// ===== SITE CONFIGURATION =====
// Easy to update configuration for the entire site
// DOMAIN RULES (LOCKED - DO NOT CHANGE):
// - Main Server IP: play.hytale-id.net
// - Backup Server IP: server.hytale-id.net
// - Realtime Map URL: http://play.hytale-id.net:8080/
// - Status API: http://play.hytale-id.net:1337/api/status

export const siteConfig = {
  name: "Hytale Indonesia",
  tagline: "Server Hytale Pertama di Indonesia",
  description: "Hytale Indonesia adalah server komunitas Hytale pertama di Indonesia, dibangun untuk memberikan pengalaman bermain premium bagi semua pemain.",
  logo: "https://i.ibb.co.com/nqQz1g9g/image-2026-01-23-001825505.png",
  
  // Server IPs (LOCKED)
  serverIP: "play.hytale-id.net",
  backupIP: "server.hytale-id.net",
  
  // API Configuration (HTTP only - LOCKED)
  api: {
    statusUrl: "https://api.hytale-id.net/api/status",
  },
  
  // External Links (HTTP for internal services - LOCKED)
  links: {
    discord: "https://discord.gg/z3PFmkCFUP",
    tiktok: "https://tiktok.com/@hytaleindonesia",
    instagram: "https://instagram.com/hytaleindonesia",
    youtube: "https://youtube.com/@hytaleindonesia",
    realtimeMap: "https://map.hytale-id.net",
  },
  
  // Navigation items
  navigation: [
    { name: "Home", href: "/" },
    { name: "Store", href: "/store" },
    { name: "Vote", href: "/vote" },
    { name: "Staff", href: "/staff" },
    { name: "Wiki", href: "/wiki" },
  ],
};

// ===== VOTE LINKS CONFIGURATION =====
// Add or remove vote links easily here
export const voteConfig = [
  {
    id: 1,
    name: "Hytale Online Servers",
    description: "Vote untuk Hytale Indonesia di Hytale Online Servers",
    url: "https://hytaleonlineservers.com/server-hytale-indonesia.1381",
    icon: "Vote",
  },
  // Add more vote links as needed
  // {
  //   id: 2,
  //   name: "Another Vote Site",
  //   description: "Vote description here",
  //   url: "https://example.com/vote",
  //   icon: "Vote",
  // },
];

// ===== STAFF CONFIGURATION =====
// Unknown staff avatar URL
const UNKNOWN_AVATAR = "https://i.ibb.co.com/DHVWRCJN/image-2026-01-30-233327381.png";

export const staffConfig = {
  unknownAvatar: UNKNOWN_AVATAR,
  owners: [
    {
      username: "NotSynz",
      role: "Owner",
      title: "Developer, Backend Engineer",
      bio: "Founder & lead developer of Hytale Indonesia. Passionate about creating the best gaming experience.",
    },
    {
      username: "Voult",
      role: "Owner",
      title: "Game System, Marketing & Staff Management",
      bio: "Handles game systems, marketing strategies, and staff coordination for Hytale Indonesia.",
    },
    {
      username: "ShiroZell",
      role: "Owner",
      title: "Social Media, Graphic Designer",
      bio: "Creates stunning visuals and manages social media presence for the community.",
    },
  ],
  developers: [
    {
      username: "NotSynz",
      role: "Developer",
      title: "Full Stack Developer",
      bio: "Lead developer working on server features and web development.",
    },
    {
      username: "KrmaL",
      role: "Developer",
      title: "Backend Developer",
      bio: "Specialized in backend systems and server optimization.",
      customAvatar: "https://hyvatar.io/render/JJE?size=256",
    },
    {
      username: "Unknown",
      role: "Developer",
      title: "Coming Soon",
      bio: "Position available for talented developers.",
      placeholder: true,
    },
  ],
  admins: [
    {
      username: "Ryaken",
      role: "Admin",
      title: "Server Administrator",
      bio: "Ensures smooth server operations and community moderation.",
    },
    {
      username: "edeenn",
      role: "Admin",
      title: "Server Administrator",
      bio: "Ensures smooth server operations and community moderation.",
    },
    {
      username: "Unknown",
      role: "Admin",
      title: "Coming Soon",
      bio: "Position available for talented administrators.",
      placeholder: true,
    },
  ],
  moderators: [
    {
      username: "Unknown",
      role: "Moderator",
      title: "Coming Soon",
      bio: "Position available for dedicated community members.",
      placeholder: true,
    },
    {
      username: "Unknown",
      role: "Moderator",
      title: "Coming Soon",
      bio: "Position available for dedicated community members.",
      placeholder: true,
    },
    {
      username: "Unknown",
      role: "Moderator",
      title: "Coming Soon",
      bio: "Position available for dedicated community members.",
      placeholder: true,
    },
  ],
  helpers: [
    {
      username: "Unknown",
      role: "Helper",
      title: "Coming Soon",
      bio: "Position available for dedicated community members.",
      placeholder: true,
    },
    {
      username: "Unknown",
      role: "Helper",
      title: "Coming Soon",
      bio: "Position available for dedicated community members.",
      placeholder: true,
    },
    {
      username: "Unknown",
      role: "Helper",
      title: "Coming Soon",
      bio: "Position available for dedicated community members.",
      placeholder: true,
    },
  ],
  specialThanks: [
    {
      username: "Moomogi",
      role: "Special Thanks",
      title: "Big Support and Donation",
      bio: "Terima kasih atas dukungan besar dan donasi yang telah diberikan untuk server Hytale Indonesia.",
      special: true,
    },
    {
      username: "Visa7",
      role: "Special Thanks",
      title: "Big Support and Donation",
      bio: "Terima kasih atas dukungan besar dan donasi yang telah diberikan untuk server Hytale Indonesia.",
      special: true,
    },
    {
      username: "RaidenMSH021",
      role: "Special Thanks",
      title: "Big Support and Donation",
      bio: "Terima kasih atas dukungan besar dan donasi yang telah diberikan untuk server Hytale Indonesia.",
      special: true,
    },
    {
      username: "Otiose",
      role: "Special Thanks",
      title: "Big Support and Donation",
      bio: "Terima kasih atas dukungan besar dan donasi yang telah diberikan untuk server Hytale Indonesia.",
      special: true,
    },
    {
      username: "ProtoDino",
      role: "Special Thanks",
      title: "Big Support and Donation",
      bio: "Terima kasih atas dukungan besar dan donasi yang telah diberikan untuk server Hytale Indonesia.",
      special: true,
    },
  ],
  supporters: {
    mithril: [
      { username: "Mevz", tier: "Mithril" },
    ],
    adamantite: [
      { username: "Xfixx", tier: "Adamantite" },
    ],
    cobalt: [],
    thorium: [
      { username: "Adastira", tier: "Thorium" },
    ],
    gold: [
      { username: "Farz", tier: "Gold" },
      { username: "NAQ2", tier: "Gold" },
      { username: "RaziFauzi30", tier: "Gold" },
      { username: "urking", tier: "Gold" },
      { username: "Shankara340", tier: "Gold" },
      { username: "Luelby", tier: "Gold" },
      { username: "Massamichy", tier: "Gold" },
    ],
    silver: [
      { username: "Eeruza", tier: "Silver" },
      { username: "Hiakevin", tier: "Silver" },
    ],
    iron: [
      { username: "STANDAR", tier: "Iron" },
      { username: "E28", tier: "Iron" },
      { username: "Its_Hannz", tier: "Iron" },
    ],
    copper: [
      { username: "Movee", tier: "Copper" },
    ],
  },
};

// ===== STORE / RANK CONFIGURATION =====
export const storeConfig = {
  description: "Setiap dukungan yang Anda berikan melalui pembelian Rank bukan sekadar transaksi, melainkan kontribusi nyata untuk Update, Maintenance, dan Peningkatan Performa server agar tetap stabil dan nyaman bagi semua pemain. Dengan menjadi donatur, Anda adalah pilar komunitas yang memungkinkan kami untuk terus berkembang, menghadirkan fitur-fitur baru, dan memberikan pengalaman bermain yang tak terlupakan. Mari tumbuh bersama dan jadilah bagian dari sejarah besar server ini!",
  importantNote: "Update Rank: Setiap ada pembaruan fitur di server, donatur akan mendapatkan perubahan/penyesuaian benefit secara otomatis sesuai dengan rank yang dimiliki.",
  tiers: [
    {
      tier: "Ultimate & Exclusive",
      color: "from-purple-500 to-pink-500",
      borderColor: "border-purple-500/50",
      ranks: [
        {
          name: "Prisma",
          subtitle: "Top Tier Rank",
          price: "IDR 1.000.000",
          color: "bg-gradient-to-r from-purple-600 to-pink-600",
          benefits: [
            "Bonus Balance: $20K",
            "Bonus Keys: 5 Survival, 5 Legendary, 5 Magical, 5 Rare, 5 Common",
            "Maksimal Homes: 20",
            "Maksimal Simple Claims: 14",
            "Maksimal Slot Auction House: 35",
            "Akses Fly Mode (/fly) & Speed Fly",
            "Akses perintah: /heal, /tp",
            "Akses perintah: /back",
            "Akses perintah: /rtp",
            "Mounts: Mosshorn, Bison",
            "Pets: Chicken Undead, Bunny, Bat Ice",
            "Prefix Gradient Pelangi (Special)",
          ],
        },
        {
          name: "Dragonite",
          price: "IDR 850.000",
          color: "bg-gradient-to-r from-orange-500 to-red-600",
          benefits: [
            "Bonus Balance: $17K",
            "Bonus Keys: 3 Survival, 5 Legendary, 3 Magical",
            "Maksimal Homes: 13",
            "Maksimal Simple Claims: 12",
            "Maksimal Slot Auction House: 18",
            "Akses Fly Mode (/fly) & Speed Fly",
            "Akses perintah: /heal, /tp",
            "Akses perintah: /back",
            "Akses perintah: /rtp",
            "Mounts: Mosshorn",
            "Pets: Chicken Undead, Bunny",
            "Akses Kit Dragonite",
          ],
        },
        {
          name: "Mithiril",
          price: "IDR 650.000",
          color: "bg-gradient-to-r from-cyan-400 to-blue-500",
          benefits: [
            "Bonus Balance: $13,5K",
            "Bonus Keys: 2 Survival, 3 Legendary, 3 Magical",
            "Maksimal Homes: 11",
            "Maksimal Simple Claims: 10",
            "Maksimal Slot Auction House: 16",
            "Akses perintah: /back",
            "Akses perintah: /rtp",
            "Akses Chat Colors (Chat Berwarna)",
            "Mounts: Mosshorn",
            "Pets: Chicken Undead, Bunny",
            "Akses Kit Mithiril",
          ],
        },
      ],
    },
    {
      tier: "Elite & Heroic",
      color: "from-yellow-500 to-amber-500",
      borderColor: "border-yellow-500/50",
      ranks: [
        {
          name: "Adamantite",
          price: "IDR 450.000",
          color: "bg-gradient-to-r from-emerald-500 to-teal-600",
          benefits: [
            "Bonus Balance: $10K",
            "Bonus Keys: 2 Survival, 3 Legendary, 3 Magical",
            "Maksimal Homes: 9",
            "Maksimal Simple Claims: 8",
            "Maksimal Slot Auction House: 14",
            "Akses perintah: /back",
            "Akses perintah: /rtp",
            "Akses Chat Colors (Chat Berwarna)",
            "Pet: Chicken Undead",
            "Akses Kit Adamantite",
          ],
        },
        {
          name: "Cobalt",
          price: "IDR 300.000",
          color: "bg-gradient-to-r from-blue-500 to-indigo-600",
          benefits: [
            "Bonus Balance: $8K",
            "Bonus Keys: 1 Survival, 2 Legendary, 2 Magical",
            "Maksimal Homes: 7",
            "Maksimal Simple Claims: 7",
            "Maksimal Slot Auction House: 12",
            "Akses perintah: /back",
            "Akses perintah: /rtp",
            "Akses Chat Colors (Chat Berwarna)",
            "Pet: Chicken Undead",
            "Akses Kit Cobalt",
          ],
        },
      ],
    },
    {
      tier: "Advanced & Premium",
      color: "from-gray-400 to-gray-500",
      borderColor: "border-gray-500/50",
      ranks: [
        {
          name: "Thorium",
          price: "IDR 200.000",
          color: "bg-gradient-to-r from-yellow-500 to-amber-600",
          benefits: [
            "Bonus Balance: $6K",
            "Bonus Keys: 2 Legendary, 3 Magical",
            "Maksimal Homes: 5",
            "Maksimal Simple Claims: 6",
            "Maksimal Slot Auction House: 10",
            "Akses perintah: /back",
            "Akses perintah: /rtp",
            "Akses Kit Thorium",
          ],
        },
        {
          name: "Gold",
          price: "IDR 125.000",
          color: "bg-gradient-to-r from-yellow-400 to-yellow-600",
          benefits: [
            "Bonus Balance: $4K",
            "Bonus Keys: 1 Legendary, 2 Magical",
            "Maksimal Homes: 4",
            "Maksimal Simple Claims: 5",
            "Maksimal Slot Auction House: 9",
            "Akses Kit Gold",
          ],
        },
      ],
    },
    {
      tier: "Starter & Common",
      color: "from-orange-400 to-orange-600",
      borderColor: "border-orange-500/50",
      ranks: [
        {
          name: "Silver",
          price: "IDR 75.000",
          color: "bg-gradient-to-r from-gray-300 to-gray-500",
          benefits: [
            "Bonus Balance: $3K",
            "Bonus Keys: 3 Magical, 1 Rare",
            "Maksimal Homes: 3",
            "Maksimal Slot Auction House: 8",
            "Akses Kit Silver",
          ],
        },
        {
          name: "Iron",
          price: "IDR 50.000",
          color: "bg-gradient-to-r from-gray-400 to-gray-600",
          benefits: [
            "Bonus Balance: $2K",
            "Bonus Keys: 1 Magical, 1 Rare",
            "Maksimal Homes: 2",
            "Maksimal Slot Auction House: 7",
            "Akses Kit Iron",
          ],
        },
        {
          name: "Copper",
          price: "IDR 25.000",
          color: "bg-gradient-to-r from-orange-400 to-orange-600",
          benefits: [
            "Bonus Balance: $1K",
            "Bonus Keys: 1 Magical",
            "Maksimal Homes: 2",
            "Maksimal Slot Auction House: 6",
            "Akses Kit Copper",
          ],
        },
      ],
    },
  ],
};

// ===== MOUNTS CONFIGURATION =====
export const mountsConfig = {
  description: "Jelajahi dunia Hytale dengan style! Koleksi mounts eksklusif yang akan membuat petualanganmu lebih epic dan memorable. Setiap mount memiliki karakteristik unik dan akan menjadi companion setia dalam setiap perjalananmu. Dapatkan mount favoritmu melalui Discord!",
  categories: [
    {
      rarity: "Rare",
      color: "from-blue-400 to-blue-600",
      borderColor: "border-blue-500/50",
      mounts: [
        {
          name: "Horse Skeleton Armored",
          price: "Rp 150.000",
          image: "/images/HorseSkeletonArmored.png",
          description: "Upgraded version dari Horse Skeleton dengan armor yang intimidating! Battle-ready mount yang perfect untuk warriors. Kombinasi antara speed, protection, dan pure awesomeness!",
          stats: {
            speed: "⭐⭐⭐⭐",
            stamina: "⭐⭐⭐⭐",
            style: "⭐⭐⭐⭐⭐"
          }
        },
      ],
    },
    {
      rarity: "Uncommon",
      color: "from-green-400 to-green-600",
      borderColor: "border-green-500/50",
      mounts: [
        {
          name: "Horse Skeleton",
          price: "Rp 100.000",
          image: "/images/horsesekeleton.png",
          description: "Kuda skeleton yang mysterious dan cool! Bergerak dengan grace yang menakutkan namun elegant. Show off your dark side dengan mount yang bikin semua orang nengok!",
          stats: {
            speed: "⭐⭐⭐⭐",
            stamina: "⭐⭐⭐",
            style: "⭐⭐⭐⭐"
          }
        },
        {
          name: "Antelope",
          price: "Rp 110.000",
          image: "/images/Antelope.png",
          description: "Rusa cepat dengan kelincahan luar biasa. Sprint speed yang impressive dan gerakan yang smooth. Perfect untuk yang suka kecepatan dan mobility tinggi dalam exploration.",
          stats: {
            speed: "⭐⭐⭐⭐⭐",
            stamina: "⭐⭐⭐",
            style: "⭐⭐⭐⭐"
          }
        },
        {
          name: "Mosshorn",
          price: "Rp 120.000",
          image: "/images/Mosshorn.png",
          description: "Creature mystical dengan moss yang tumbuh di tanduknya. Koneksi dengan nature yang kuat memberikan aura tenang dan damai. Companion sempurna untuk druid dan nature lovers.",
          stats: {
            speed: "⭐⭐⭐",
            stamina: "⭐⭐⭐⭐⭐",
            style: "⭐⭐⭐⭐"
          }
        },
        {
          name: "Mosshorn Plain",
          price: "Rp 120.000",
          image: "/images/Mosshorn Plain.png",
          description: "Varian Mosshorn dengan appearance yang lebih clean dan refined. Tetap mempertahankan kekuatan nature magic tapi dengan style yang lebih subtle dan elegant.",
          stats: {
            speed: "⭐⭐⭐",
            stamina: "⭐⭐⭐⭐⭐",
            style: "⭐⭐⭐⭐"
          }
        },
      ],
    },
    {
      rarity: "Common",
      color: "from-gray-400 to-gray-500",
      borderColor: "border-gray-500/50",
      mounts: [
        {
          name: "Horse",
          price: "Rp 75.000",
          image: "/images/horse.png",
          description: "Kuda klasik yang tangguh dan dapat diandalkan. Sempurna untuk pemula yang ingin memulai petualangan dengan companion setia. Speed moderat dengan stamina yang baik untuk perjalanan jarak jauh.",
          stats: {
            speed: "⭐⭐⭐",
            stamina: "⭐⭐⭐⭐",
            style: "⭐⭐"
          }
        },
        {
          name: "Goat",
          price: "Rp 75.000",
          image: "/images/goat.png",
          description: "Kambing gunung yang lincah dan gesit. Mampu melewati medan berbatu dengan mudah. Pilihan terbaik untuk explorer yang suka adventure di pegunungan dan terrain sulit.",
          stats: {
            speed: "⭐⭐",
            stamina: "⭐⭐⭐⭐",
            style: "⭐⭐⭐"
          }
        },
      ],
    },
  ],
};

// ===== FEATURE IMAGES CONFIGURATION =====
export const featureImages = [
  {
    id: 1,
    image: "https://i.ibb.co.com/Y4JwKbLr/image-2026-01-22-233049635.png",
    title: "Dunia yang Luas",
    description: "Jelajahi dunia Hytale yang penuh petualangan dengan landscape yang memukau dan berbagai biome unik.",
  },
  {
    id: 2,
    image: "https://i.ibb.co.com/j90Ck8vk/image-2026-01-22-233230575.png",
    title: "Combat System",
    description: "Nikmati sistem pertarungan yang dinamis dengan berbagai senjata dan kemampuan khusus.",
  },
  {
    id: 3,
    image: "https://i.ibb.co.com/jS39Xx5/image-2026-01-22-233147736.png",
    title: "Crates & Kits",
    description: "Dapatkan berbagai hadiah menarik dari Crates dan gunakan Kit untuk memulai petualanganmu dengan lebih mudah.",
  },
  {
    id: 4,
    image: "https://i.ibb.co.com/VcjfPNgG/image-2026-01-22-233300083.png",
    title: "Komunitas Aktif",
    description: "Bergabung dengan ribuan pemain Indonesia dalam komunitas yang ramah dan aktif.",
  },
  {
    id: 5,
    image: "https://i.ibb.co.com/SwWPYMGY/image-2026-01-22-233325546.png",
    title: "Events & Rewards",
    description: "Ikuti event seru dan dapatkan rewards eksklusif hanya di Hytale Indonesia.",
  },
];

// ===== WIKI CONTENT CONFIGURATION =====
export const wikiContent = {
  "getting-started": {
    title: "Getting Started",
    content: `
# Memulai Petualangan

## Selamat Datang di Hytale Indonesia! 🎮

Panduan ini akan membantu kamu memulai petualangan di server kami.

## Langkah 1: Persiapan

### Download & Install
1. Download Hytale dari [website resmi](https://hytale.com)
2. Install game di komputer kamu
3. Pastikan sistem requirements terpenuhi:
   - **OS**: Windows 10/11, macOS, atau Linux
   - **RAM**: Minimal 4GB (8GB recommended)
   - **GPU**: Compatible dengan OpenGL 4.0+
   - **Storage**: 10GB free space

### Buat Account
- Register account di Hytale launcher
- Verifikasi email kamu
- Login dan update game ke versi terbaru

## Langkah 2: Cara Connect ke Server

### Tutorial Langkah demi Langkah

**Step 1: Buka Multiplayer**

![Step 1](/images/Join1.jpg)

Buka Hytale launcher dan pilih menu **Multiplayer**.

---

**Step 2: Add Server**

![Step 2](/images/Join2.jpg)

Klik tombol **"Add Server"** atau **"Direct Connect"**.

---

**Step 3: Masukkan Server Details**

![Step 3](/images/Join3.jpg)

Isi informasi server seperti berikut:

**📝 Server Name:**  
\`Hytale Indonesia\`

**🌐 Connection Address:**  
\`play.hytale-id.net\`

---

**Step 4: Connect & Accept Rules**

Klik **"Done"** atau **"Connect"** dan tunggu hingga loading selesai.

⚠️ **Penting**: Jangan lupa untuk menyetujui Rules ketika pertama kali bergabung!

🎉 **Selamat! Kamu sudah terhubung ke Hytale Indonesia!**

---

### 📝 Catatan Penting

**Tidak Ada System Login/Register**
- Server Hytale Indonesia **TIDAK** menggunakan system \`/login\` atau \`/register\`
- Kamu bisa langsung bermain setelah connect
- Account kamu aman dengan Hytale authentication

## Troubleshooting 🔧

### Problem 1: Firewall Blocking Connection

Jika kamu mengalami masalah connection karena firewall, ikuti langkah berikut:

**Step 1: Buka Windows Defender Firewall**

![Firewall Step 1](/images/fw1.jpg)

- Buka **Control Panel** → **Windows Defender Firewall**
- Atau search "Firewall" di Windows Search

---

**Step 2: Allow App Through Firewall**

![Firewall Step 2](/images/fw2.jpg)

- Klik **"Allow an app or feature through Windows Defender Firewall"**
- Cari **Hytale** dalam list aplikasi

---

**Step 3: Enable Both Networks**

![Firewall Step 3](/images/fw3.jpg)

- Centang **Private** dan **Public** network untuk Hytale
- Klik **OK** untuk save changes

---

**Alternative: Disable Firewall Temporarily**
- Jika masih bermasalah, coba disable firewall sementara
- **Settings** → **Update & Security** → **Windows Security** → **Firewall & Network Protection**

### Problem 2: Still Can't Connect? Use VPN!

**Recommended VPN Solutions:**

**Option 1: Cloudflare WARP** (Free & Fast)

![WARP VPN](/images/cfwrap1.png)

1. Download WARP: [Download Here](https://1111-releases.cloudflareclient.com/win/latest)
2. Install aplikasi dan buka
3. Klik tombol **Connect** untuk aktifkan WARP
4. Tunggu hingga status berubah menjadi **Connected**
5. Reconnect ke server Hytale Indonesia

---

**Option 2: Surfshark VPN** (Premium Option)

**Step 1: Download Surfshark**

![Surfshark VPN Step 1](/images/vpn1.png)

Download Surfshark: [Download Here](https://downloads.surfshark.com/windows/latest/SurfsharkSetup.exe)

---

**Step 2: Pilih Lokasi Server**

![Surfshark VPN Step 2](/images/vpn2.png)

- Pilih lokasi rekomendasi yang diberikan aplikasi
- Atau gunakan lokasi **Indonesia** untuk ping yang lebih stabil
- Klik **Connect** dan reconnect ke server Hytale Indonesia

---

### Problem 3: Connection Timed Out

Jika masih mengalami timeout setelah firewall dan VPN, coba ubah DNS settings:

**Langkah-langkah:**

1. **Buka Network Connections**
   - Press \`Win + R\`, ketik \`ncpa.cpl\`, Enter
   - Atau buka Control Panel → Network and Sharing Center → Change adapter settings

2. **Masuk ke Properties**
   - Right-click pada network adapter yang aktif (WiFi/Ethernet)
   - Pilih **Properties**

3. **Configure IPv4**
   - Scroll dan cari **Internet Protocol Version 4 (TCP/IPv4)**
   - Double-click atau klik **Properties**

4. **Ubah DNS Settings**
   - Pilih **"Use the following DNS server addresses"**
   - **Preferred DNS server**: \`1.1.1.1\` (Cloudflare)
   - **Alternate DNS server**: \`8.8.8.8\` (Google)
   - Centang **"Validate settings upon exit"**

5. **Save & Restart**
   - Klik **OK** untuk save
   - Restart network adapter atau reboot PC
   - Reconnect ke server

---

### Opsi Terakhir: Validate Hytale Launcher

Jika semua cara di atas masih gagal, coba validate launcher:

**Step 1: Buka Settings Launcher**

![Validate Step 1](/images/verified1.png)

Buka **Hytale Launcher** dan masuk ke menu **Settings**.

---

**Step 2: Pilih Bagian Uninstall**

![Validate Step 2](/images/verified2.png)

Cari dan pilih bagian **Uninstall** di menu settings.

---

**Step 3: Pilih Release Terbaru**

![Validate Step 3](/images/verified3.png)

Pilih **Release terbaru** atau versi yang kalian gunakan.

---

**Step 4: Pencet Tombol Validate**

![Validate Step 4](/images/verified3.png)

Klik tombol **Validate** untuk verify game files dan tunggu prosesnya selesai.

---

**Additional Steps:**
1. **Repair Hytale Installation**
   - Buka Hytale Launcher
   - Settings → Repair/Verify Game Files

2. **Clear DNS Cache**
   - Buka Command Prompt (Run as Administrator)
   - Ketik: \`ipconfig /flushdns\`
   - Press Enter

3. **Restart Router**
   - Matikan router selama 30 detik
   - Nyalakan kembali dan tunggu sampai stabil

4. **Contact Support**
   - Jika masih bermasalah, hubungi support di Discord
   - Channel: #support atau create ticket

## Langkah 3: First Steps di Server

### Spawn Area
- Kamu akan spawn di **Hytale Indonesia Hub**
- Explore area spawn dan kenali fasilitasnya
- Cek papan info untuk update terbaru

### Starter Kit
Claim starter kit gratis:
\`\`\`
/kit starter
\`\`\`

Kit berisi:
- Basic tools (pickaxe, axe, sword)
- Food untuk survival
- Building blocks
- Starter money: $1,000

### Essential Commands
Commands penting untuk pemula:
\`\`\`
/spawn - Kembali ke spawn
/rules - Baca server rules
/help - List semua commands
/rtp - Random teleport ke survival world
/claim - Claim area build kamu
\`\`\`

## Tips untuk Pemula 💡

### ✅ DO:
- Baca rules sebelum bermain (\`/rules\`)
- Claim area build kamu dengan \`/claim\`
- Join Discord untuk update dan bantuan
- Tanya staff jika ada yang bingung
- Ikuti events untuk rewards

### ❌ DON'T:
- Grief atau merusak build orang lain
- Spam chat
- Begging items/money dari player lain
- Menggunakan hacks atau cheat
- AFK di farm untuk farming otomatis

## Need Help? 🆘

### In-Game Support
- \`/ticket create\` - Buat support ticket
- \`/helpop <pesan>\` - Minta bantuan staff online

### Discord Support
- Join server Discord
- Buka channel #support
- Staff akan membantu dalam 5-15 menit

### FAQ
Cek FAQ section untuk jawaban pertanyaan umum!
    `,
  },
  "tentang-hytale": {
    title: "Tentang Hytale",
    content: `
# Gameplay Mechanics

## Combat System ⚔️

### Weapon Types
Hytale memiliki berbagai jenis senjata dengan mekanik unik:

**Melee Weapons:**
- **Swords** - Damage tinggi, fast attack speed
  - Special: Sweep attack (AoE damage)
  - Best for: Close combat, PvP
- **Axes** - Damage sangat tinggi, slow attack
  - Special: Shield break, armor penetration
  - Best for: High damage output, boss fights
- **Spears** - Medium damage, extended reach
  - Special: Throw attack, knockback
  - Best for: Keeping distance, mounted combat

**Ranged Weapons:**
- **Bows** - Classic ranged weapon
  - Types: Short bow, Long bow, Composite bow
  - Special: Charge untuk extra damage
- **Crossbows** - High damage, slow reload
  - Special: Piercing shot
  - Best for: High burst damage
- **Magic Staffs** - Elemental damage
  - Types: Fire, Ice, Lightning, Poison
  - Special: Area effects, status effects

### Combat Mechanics

**Blocking & Parrying:**
- Hold Right-Click untuk block dengan shield
- Perfect timing block = parry (counter attack opportunity)
- Shields reduce damage by 50-80%

**Dodging & Movement:**
- Double-tap direction key untuk dodge roll
- Dodge roll memberikan brief invincibility (i-frames)
- Stamina system - manage your energy!

**Combos:**
- Chain attacks untuk combo multiplier
- Light → Light → Heavy untuk optimal DPS
- Special weapons memiliki unique combo finishers

## Crafting System 🔨

### Basic Crafting

**Crafting Table:**
- 3x3 crafting grid
- Recipe book (press 'R')
- Quick craft favorit items

**Workbenches:**
Specialized crafting stations:
- **Smithing Table** - Weapons & armor
- **Enchanting Table** - Enchantments
- **Alchemy Table** - Potions & elixirs
- **Cooking Station** - Food & buffs
- **Fletcher Table** - Bows & arrows

### Advanced Crafting

**Material Tiers:**
1. Wood → Stone → Iron
2. Gold → Diamond → Emerald
3. Mithril → Adamantite → Dragonite

**Quality System:**
- Normal (white)
- Uncommon (green) - +10% stats
- Rare (blue) - +25% stats + 1 bonus
- Epic (purple) - +50% stats + 2 bonuses
- Legendary (gold) - +100% stats + 3 bonuses + special effect

**Crafting Skills:**
- Level up crafting skill untuk unlock recipes
- Higher skill = better quality chance
- Specialize in certain crafts untuk mastery bonuses

## Building System 🏗️

### Block Types

**Structure Blocks:**
- Wood planks, Stone bricks, Metal blocks
- Different variants: smooth, rough, decorated
- Rotation & orientation system

**Functional Blocks:**
- Doors, Gates, Trapdoors
- Stairs, Slabs, Fences
- Windows, Shutters
- Furniture blocks

**Special Blocks:**
- Glowing blocks (lighting)
- Animated blocks (moving parts)
- Logic blocks (redstone-like)
- Interactive blocks (buttons, levers, pressure plates)

### Building Tools

**Block Placer:**
- Right-click untuk place block
- Shift + Right-click untuk fast place
- Ctrl + Scroll untuk rotate block

**Block Wand (Creative):**
- \`/give @s wand\`
- Select area dengan left & right click
- Copy, paste, replace blocks
- Undo/redo functionality

**WorldEdit Commands:**
- \`//set <block>\` - Fill selection
- \`//replace <old> <new>\` - Replace blocks
- \`//copy\` & \`//paste\` - Copy structures
- \`//undo\` & \`//redo\` - Undo changes

### Building Tips

**Planning:**
1. Sketch design terlebih dahulu
2. Gather materials sebelum mulai
3. Use symmetry tools untuk precise builds

**Techniques:**
- Layer by layer building
- Use scaffolding untuk reach high places
- Mix block types untuk texture variety
- Add depth dengan stairs & slabs

## Survival Mechanics 🌲

### Health & Hunger

**Health System:**
- 20 hearts (40 HP) default
- Regenerates slowly with full hunger
- Combat, fall damage, drowning depletes health
- Use potions/food untuk instant heal

**Hunger System:**
- 20 hunger points
- Depletes with running, jumping, fighting
- Low hunger = no health regen + slower movement
- Eat food to restore hunger

### Environmental Hazards

**Weather:**
- Rain - Reduced visibility, slippery surfaces
- Snow - Cold damage without proper gear
- Storms - Lightning damage, wind effects
- Fog - Very reduced visibility

**Temperature:**
- Cold biomes - Need warm clothing
- Hot biomes - Need cooling gear
- Hypothermia/Heatstroke effects
- Campfires & torches provide warmth

**Day/Night Cycle:**
- Day - Safe exploration
- Night - More monsters spawn
- Sleep to skip night (requires bed)
- Moon phases affect monster spawn rates

## Economy & Trading 💰

### Currency System

**Money Types:**
- **Coins** - Main currency (earned in-game)
- **Gems** - Premium currency (donation rewards)
- **Tokens** - Event currency (limited time)

**Earning Money:**
1. **Quests** - Daily, weekly, seasonal quests
2. **Monster Hunting** - Drops coins + loot
3. **Mining & Gathering** - Sell resources
4. **Trading** - Player-to-player economy
5. **Jobs** - Specialized income (miner, farmer, etc.)
6. **Events** - Participate untuk rewards

### Player Trading

**Trade System:**
- \`/trade <player>\` - Initiate trade
- Both players place items/money
- Accept when satisfied
- Anti-scam protection

**Auction House:**
- \`/ah\` - Open auction house
- List items untuk dijual
- Browse & bid on items
- 5% tax per transaction

**Shop System:**
- \`/shop\` - Server shop (buy/sell)
- Player shops - Create your own shop
- \`/shopkeeper\` - Create NPC shopkeeper

## Character Progression 📊

### Leveling System

**Experience (XP):**
- Gained from killing mobs, mining, crafting
- Level up to increase stats
- Max level: 100 (can prestige for bonuses)

**Stat System:**
Each level grants stat points to allocate:
- **Strength** - Melee damage +2%
- **Dexterity** - Attack speed +1%, Crit +0.5%
- **Constitution** - Health +2 HP
- **Intelligence** - Magic damage +2%, Mana +5
- **Luck** - Drop rate +1%, Crit damage +1%

### Skills & Abilities

**Skill Trees:**
Three main branches:
1. **Combat** - Weapon mastery, combat techniques
2. **Crafting** - Resource gathering, creation skills
3. **Magic** - Elemental spells, enchantments

**Active Abilities:**
Unlock & equip abilities (max 4):
- Cooldown-based usage
- Mana cost
- Upgradeable dengan skill points

**Passive Abilities:**
Always-active bonuses:
- Increased damage
- Resource multipliers
- Movement speed
- Auto-pickup range
    `,
  },
  faq: {
    title: "FAQ - Frequently Asked Questions",
    content: `
# FAQ - Frequently Asked Questions

Jawaban untuk pertanyaan yang sering ditanyakan!

## 🎮 General

### Q: Apakah server ini gratis?
**A:** Ya! Server 100% gratis untuk dimainkan. Rank adalah donation optional untuk support server development dan mendapatkan perks tambahan.

## Teleportation Commands 🚀

### Home System
\`\`\`
/home - Teleport ke home default
/home [name] - Teleport ke home spesifik
/sethome - Set home di lokasi saat ini
/sethome [name] - Set named home
/delhome [name] - Delete home
/homes - List semua homes
\`\`\`

**Limits:**
- Default: 2 homes
- Iron: 3 homes
- Silver: 4 homes
- Gold: 5 homes
- etc. (check /ranks untuk detail)

### Warps
\`\`\`
/warp [name] - Teleport ke warp
/warps - List available warps
\`\`\`

**Public Warps:**
- /warp shop - Server shop
- /warp pvp - PvP arena  
- /warp mine - Public mining area
- /warp farm - Public farm
- /warp end - End portal
- /warp nether - Nether portal

### Player Teleport
\`\`\`
/tpa <player> - Request teleport to player
/tpahere <player> - Request player teleport to you
/tpaccept - Accept TP request
/tpdeny - Deny TP request
/tptoggle - Toggle TP requests
\`\`\`

### Random Teleport
\`\`\`
/rtp - Random teleport (safe location)
/wild - Alternative RTP command
\`\`\`

**Ranks dengan RTP boost:**
- Gold: Reduced cooldown
- Emerald: No cooldown
- Diamond+: Choose biome preference

## Economy Commands 💰

### Balance
\`\`\`
/balance - Check your money
/bal - Alias untuk /balance
/baltop - Leaderboard richest players
/pay <player> <amount> - Send money
\`\`\`

### Shopping
\`\`\`
/shop - Open server shop
/sell hand - Sell item di tangan
/sell all - Sell semua items di inventory
/sellmenu - GUI untuk sell items
\`\`\`

### Auction House
\`\`\`
/ah - Open auction house
/ah sell <price> - List item for sale
/ah search [item] - Search items
/ah expired - View expired listings
/ah sold - View sold items history
\`\`\`

### Trading
\`\`\`
/trade <player> - Start trade with player
/trade accept - Accept trade
/trade decline - Decline trade
\`\`\`

## Claim System 🛡️

### Basic Claims
\`\`\`
/claim - Create claim di area saat ini
/abandonclaim - Delete claim saat ini
/claimlist - List all your claims
/trust <player> - Trust player di claim
/untrust <player> - Untrust player
/accesstrust <player> - Give access permission
/containertrust <player> - Give container permission
\`\`\`

### Advanced Claims
\`\`\`
/claimexplosions - Toggle explosion damage
/subdivideclaims - Create subclaim
/restrictsubclaim - Restrict subclaim permissions
/claiminfo - View claim information
/claimbook - Get claim visualizer tool
\`\`\`

**Claim Sizes:**
- Default: 2500 blocks
- Rank bonus: +1000 per rank tier
- Max size: 25,000 blocks

## Social Commands 💬

### Chat
\`\`\`
/msg <player> <message> - Private message
/r <message> - Reply to last PM
/ignore <player> - Ignore player messages
/unignore <player> - Unignore player
/mail send <player> <message> - Send offline mail
/mail read - Read your mails
\`\`\`

### Chat Channels
\`\`\`
/g <message> - Global chat (default)
/l <message> - Local chat (100 block radius)
/trade <message> - Trade chat
/help <message> - Help chat
/ch [channel] - Switch channel permanently
\`\`\`

### Friends
\`\`\`
/friend add <player> - Add friend
/friend remove <player> - Remove friend
/friend list - View friends list
/friend online - View online friends
\`\`\`

### Party System
\`\`\`
/party create - Create party
/party invite <player> - Invite to party
/party accept - Accept invite
/party leave - Leave party
/party kick <player> - Kick member (leader only)
/pc <message> - Party chat
\`\`\`

## Kits & Rewards 🎁

### Kits
\`\`\`
/kit - View available kits
/kit starter - Claim starter kit (once)
/kit daily - Daily reward kit (24h cooldown)
/kit [rankname] - Claim rank kit
\`\`\`

**Kit Cooldowns:**
- Starter: One-time
- Daily: 24 hours
- Rank kits: 6-24 hours (depends on rank)

### Rewards
\`\`\`
/vote - Vote links & rewards
/voteparty - Check voteparty progress
/bonus - Claim login bonus
/playtime - Check your playtime
/rewards - View achievement rewards
\`\`\`

## Combat Commands ⚔️

### PvP
\`\`\`
/pvp - Toggle PvP mode
/pvpstats - View your PvP statistics
/duel <player> - Challenge to duel
/duel accept - Accept duel challenge
/arena - Join PvP arena
\`\`\`

### Combat Info
\`\`\`
/skills - View combat skills
/stats - View player statistics
/leaderboard kills - Top killers
/leaderboard deaths - Death statistics
\`\`\`

## Utility Commands 🔧

### Item Management
\`\`\`
/repair - Repair item di tangan (VIP)
/repair all - Repair semua items (Donator)
/condense - Condense items (9 → 1 block)
/dispose - Open trash GUI
/hat - Wear item as hat (VIP)
\`\`\`

### Inventory
\`\`\`
/ec - Open enderchest
/backpack - Open backpack (VIP)
/craft - Open crafting table
/anvil - Open anvil (VIP)
/grindstone - Open grindstone
\`\`\`

### Information
\`\`\`
/iteminfo - Info tentang item
/near - List nearby players
/whois <player> - Player information
/seen <player> - Last seen time
/playtime <player> - Check playtime
\`\`\`

## Jobs & Skills 💼

### Jobs
\`\`\`
/jobs - Open jobs menu
/jobs join [job] - Join a job
/jobs leave [job] - Leave job
/jobs info [job] - Job information
/jobs stats - Your job statistics
/jobs top [job] - Job leaderboard
\`\`\`

**Available Jobs:**
- Miner - Mining rewards
- Woodcutter - Forestry rewards
- Farmer - Farming rewards
- Hunter - Hunting rewards
- Builder - Building rewards
- Fisherman - Fishing rewards

### McMMO Skills
\`\`\`
/mcmmo - McMMO help
/stats - Your skill levels
/[skillname] - Specific skill info
  Example: /mining, /woodcutting, /archery
/mctop - Skill leaderboards
/party - McMMO party system
\`\`\`

## Admin/Moderator (Staff Only) 🛡️

### Moderation
\`\`\`
/kick <player> [reason]
/ban <player> [reason]
/tempban <player> <time> [reason]
/unban <player>
/mute <player> [time]
/unmute <player>
/warn <player> <reason>
/warnings <player>
\`\`\`

### Administration
\`\`\`
/tp <player>
/tphere <player>
/tppos <x> <y> <z>
/god [player]
/fly [player]
/gamemode <mode> [player]
/heal [player]
/feed [player]
\`\`\`

### World Management
\`\`\`
/time set <time>
/weather <type>
/setworldspawn
/world <world>
/clearlag
\`\`\`

## Tips & Tricks 💡

### Command Shortcuts
- Kebanyakan commands punya alias pendek
- Tab-completion untuk player names
- Arrow keys untuk command history
- Shift + Up/Down untuk scroll chat

### Permission Ranks
Commands availability depends on rank:
- 🟦 **Default**: Basic commands
- 🟩 **VIP**: Utility commands
- 🟨 **Premium**: Advanced features
- 🟥 **Donator**: All features + bonuses

### Getting Help
- Gunakan \`/help [command]\` untuk detailed info
- Join Discord untuk community support
- \`/ticket create\` untuk staff assistance
- \`/helpop\` untuk urgent in-game help

### Command Cooldowns
Beberapa commands ada cooldown:
- /rtp: 5 minutes
- /heal: 30 seconds (VIP)
- /repair: 1 minute (VIP)
- /tpa: 10 seconds
    `,
  },
  "tentang-hytale": {
    title: "Tentang Hytale",
    content: `
# Tentang Hytale

## 🎮 Apa itu Hytale?

Hytale adalah **block-based sandbox RPG** yang dikembangkan oleh Hypixel Studios, menggabungkan elemen terbaik dari berbagai genre gaming.

### Core Features

**🏗️ Sandbox Building**  
Kreativitas tanpa batas dengan advanced building tools

**⚔️ RPG Elements**  
Character progression, quests, dan storyline mendalam

**🌍 Adventure Mode**  
Procedurally generated world dengan infinite possibilities

**🎲 Mini-games**  
Multiplayer fun dengan komunitas aktif

**🔧 Modding Support**  
Create custom content dengan official tools

---

## 📜 Sejarah Hytale

> Perjalanan dari konsep hingga menjadi reality

### Timeline Development

\`\`\`
2015 ——————○—————— 2018 ——————○—————— 2020 ——————○—————— 2026
        │               │               │               │
    Dimulai        Announce      Riot Games      Early Access
    Project        Trailer       Acquisition       Release
                   (56M+ views)  Partnership    (13 Januari)
\`\`\`

**🚀 2015 - Project Start**  
Pengembangan dimulai oleh Hypixel team, creators of Hypixel Minecraft Server (100M+ players)

**📢 2018 - Announcement Trailer**  
Trailer perdana dirilis dan viral dengan 56M+ views, membangun hype massive di komunitas gaming

**🤝 2020 - Riot Games Partnership**  
Akuisisi oleh Riot Games untuk development support dan resources yang lebih besar

**🔄 2025 - Back to Independent**  
Kembali ke independent studio untuk creative freedom yang lebih besar

**🎉 2026 - Early Access Release**  
Official release 13 Januari untuk semua platform (PC, Console, Mobile)

### 👥 Hypixel Studios

Founded oleh creators of **Hypixel Minecraft Server** (server terbesar di dunia dengan **100M+ players**)

**Expertise:**
- ✅ Game design & development 
- ✅ Server management & scaling
- ✅ Community building (proven track record)
- ✅ Content creation tools

---

## ⭐ Game Features

### 🌍 World Generation

**Procedural Generation System**
- ♾️ Infinite world dengan unique biomes
- 🏔️ Cave systems & underground dungeons
- 🌦️ Dynamic weather & seasons
- 🌙 Day/night cycle dengan moon phases

**Adventure Zones**

**🌲 Zone 1: Emerald Grove** ⭐ Easy  
Temperate forests, rivers, perfect untuk pemula

**🏜️ Zone 2: Howling Sands** ⭐⭐ Medium  
Desert wasteland dengan sandstorms & ancient ruins

**❄️ Zone 3: Boreal Forest** ⭐⭐⭐ Hard  
Snowy mountains, blizzards, ice caves

**🌋 Zone 4: Devastated Lands** ⭐⭐⭐⭐ Very Hard  
Volcanic danger, lava flows, extreme heat

**🌌 Zone 5: The Void** ⭐⭐⭐⭐⭐ Extreme  
End-game content, mysterious dimension

### ⚔️ Combat System

**Weapon Types**

**⚔️ Melee Weapons**  
Swords, Axes, Spears - Combos & blocking system

**🏹 Ranged Weapons**  
Bows, Crossbows - Charged shots & precision

**🔮 Magic Weapons**  
Elemental Staffs - Area effects & status damage

**🛡️ Defense Equipment**  
Shields - Advanced parrying system
- 🎯 Directional attacks
- 🛡️ Blocking & parrying
- 🏃 Dodge rolling
- ⚡ Combo system
- 🎮 Skill-based gameplay

### 🏗️ Building & Creating

**Block System**
- 🧱 100+ block types dengan variants
- 🔄 Rotation & orientation system
- 📐 Vertical slabs & micro-blocks
- 🎨 Texture variants (smooth, rough, weathered)

**Creation Tools**

**🛠️ In-game Editor**  
Build mode dengan advanced features & real-time editing

**🎨 Model Maker**  
Create custom 3D models & animations

**📦 Prefab System**  
Save & share creations dengan komunitas

**🗺️ World Painter**  
Large-scale terrain editing & sculpting

**Character System**
- 👤 Customizable appearance
- 📊 Stats & attributes
- 🌳 Skill trees
- ⚔️ Equipment loadouts

**Progression**
- 📖 Quest system (main + side)
- 🏆 Achievement system
- 📈 Leveling & experience
- 👥 Faction reputation

**Loot System**

⚪ **Common (White)** - Base stats  
🟢 **Uncommon (Green)** - +10% stats  
🔵 **Rare (Blue)** - +25% stats + 1 bonus effect  
🟣 **Epic (Purple)** - +50% stats + 2 bonus effects  
🟡 **Legendary (Gold)** - +100% stats + 3 bonus effects + special ability

### 🌐 Multiplayer

**Server Capabilities**
- 👥 1000+ players capacity
- 🎮 Cross-play support
- 🛡️ Anti-cheat protection
- ⚡ Lag-free performance

**Mini-games**
- ⚔️ PvP arenas
- 🏎️ Racing challenges
- 🧩 Puzzle maps
- 🎯 Custom game modes

### 🔧 Modding & Customization

**Official Tools**

**🎨 Model Maker**  
3D model creation tool untuk custom content

**⚙️ Scripting API**  
Custom behaviors & mechanics dengan code

**🎭 Resource Packs**  
Textures & sounds customization

**🗺️ Map Editor**  
World creation & editing tools

**Mod Support**
- ✅ Official modding API
- ✅ Mod marketplace
- ✅ Easy installation
- ✅ Server & client-side mods

---

## 🇮🇩 Hytale Indonesia Server

### 🏆 Server Unggulan #1 Indonesia

Server komunitas Hytale pertama & terbesar di Indonesia dengan **premium quality & local community**.

**Why Choose Us?**

- ✅ **Server 24/7** - Uptime 99.9% guaranteed
- ✅ **Premium Hardware** - Zero lag, smooth performance
- ✅ **Bahasa Indonesia** - Full localization
- ✅ **Active Community** - Discord 1000+ members
- ✅ **Regular Events** - Weekly dengan rewards menarik
- ✅ **Anti-Cheat** - Fair gameplay dijamin
- ✅ **Dedicated Staff** - Responsive & helpful
- ✅ **No Pay-to-Win** - Fair untuk semua player

### 🎮 Game Modes

**🏡 Survival Mode**  
Classic survival experience - Economy, land claims, player shops, jobs system

**🎨 Creative Mode**  
Unlimited building freedom - Plots, WorldEdit tools, build competitions

**⚔️ PvP Mode**  
Competitive combat arena - Practice duels, tournaments, ranked matches

**🎲 Minigames**  
Fun mini-games - Bedwars, Skywars, Build Battle, dan lainnya

### 💎 Server Features

**🏦 Economy System**
- Balanced money system
- Player trading & auction
- Shop system
- Jobs untuk passive income

**🛡️ Protection**
- GriefPrevention claims
- Rollback support
- Anti-grief system
- 24/7 staff monitoring

**👥 Social Features**
- Party system
- Friend lists
- Chat channels & DMs
- Marriage system

**🎖️ Rank System**
- Free rank progression
- Donator ranks dengan perks
- Special benefits
- Rank upgrades available

### 🌟 Keunggulan Kami

**1. 🇮🇩 Komunitas Indonesia**
- Bahasa Indonesia sebagai bahasa utama
- Timezone friendly (WIB/WITA/WIT)
- Perayaan hari besar Indonesia
- Gameplay style ala Indonesia

**2. ⚖️ Fair Play**
- Tidak ada pay-to-win
- Semua konten accessible gratis
- Rank hanya support server
- Kesempatan sama untuk semua

**3. 🔄 Regular Updates**
- Konten baru setiap minggu
- Bug fixes cepat
- Saran komunitas di-implement
- Mengikuti update official Hytale

**4. 👨‍💼 Active Staff**
- Monitoring 24/7
- Response time cepat (<15 menit)
- Helpful & ramah
- Penegakan rules yang adil

### 📱 Join Our Community!

**Discord**: [discord.gg/z3PFmkCFUP](https://discord.gg/z3PFmkCFUP)
- 📢 Announcements & updates
- 💬 Community chat
- 🆘 Support channels  
- 🎉 Event notifications
- 🎤 Voice channels

**Social Media**
- 📷 Instagram: [@hytaleindonesia](https://instagram.com/hytaleindonesia)
- 🎵 TikTok: [@hytaleindonesia](https://tiktok.com/@hytaleindonesia)
- 🎥 YouTube: Hytale Indonesia

**Website**: [hytale-id.net](https://hytale-id.net)
- 📊 Server info & statistics
- 📚 Wiki documentation
- 🛒 Rank store
- 📝 Staff applications

---

## 🎯 Game Modes Detail

### 🗺️ Adventure Mode
**Story-driven Gameplay**

Primary content dengan storyline mendalam:
- 📖 Main questline
- 🗺️ Side quests & exploration
- 👹 Epic boss battles
- 🏰 Dungeon crawling
- 🌍 Infinite procedural world

### 🎨 Creative Mode
**Unlimited Creativity**

Perfect untuk builders:
- 🧱 All blocks unlocked
- ✈️ Flying enabled
- ⚡ Instant placement
- 🔧 WorldEdit tools
- 💾 Save & share creations

### 🌌 Orbis (The World)
**Massive Living World**

Procedurally generated dengan:
- 🗺️ Multiple biomes & ecosystems
- 🦁 Dynamic wildlife
- 🏔️ Natural landmarks
- 🌦️ Weather systems
- 🌱 Resource generation
- Weather systems
- Seasonal changes

**Exploration:**
- Points of interest
- Hidden secrets
- Rare resources
- Ancient ruins
- Monster lairs

## Technical Specifications 🖥️

### System Requirements

**Minimum:**
- OS: Windows 10 64-bit
- CPU: Intel i5-4690 / AMD Ryzen 3
- RAM: 4GB
- GPU: GTX 960 / RX 560
- Storage: 10GB

**Recommended:**
- OS: Windows 11 64-bit
- CPU: Intel i7-8700 / AMD Ryzen 5 3600
- RAM: 8GB
- GPU: RTX 2060 / RX 5700
- Storage: 20GB SSD

### Performance
- 60+ FPS on recommended specs
- Render distance up to 32 chunks
- Real-time shadows & lighting
- Dynamic weather effects
- Particle systems

### Server Technology
- Custom engine untuk optimal performance
- Low latency (< 50ms untuk Indonesia)
- DDoS protection
- Auto-save every 5 minutes
- Backup every 6 hours

## Community & Support 🤝

### Getting Help

**In-Game:**
- \`/helpop <message>\` - Request staff help
- \`/ticket create\` - Create support ticket
- Ask in chat (players helpful!)

**Discord:**
- #support channel
- Staff response dalam 5-15 minutes
- Community helpers available
- FAQ channel

**Website:**
- Wiki documentation
- Tutorial videos
- Forum discussions
- Ticket system

### Contributing
**Help the Community:**
- Create tutorials
- Share builds
- Report bugs
- Suggest features
- Help new players

**Content Creation:**
- Stream gameplay
- Make YouTube videos
- Write guides
- Create art
- Build maps

### Rules & Guidelines
Please read \`/rules\` carefully:
- Respect all players
- No cheating/hacking
- No griefing
- Follow staff instructions
- Keep chat friendly

## Future Updates 🚀

### Upcoming Features
- New mini-games
- More biomes & zones
- Additional weapons
- Magic system expansion
- Pet system
- Guild/Clan features

### Planned Events
- Build competitions
- PvP tournaments
- Treasure hunts
- Seasonal events
- Community challenges

### Long-term Goals
- Mobile version support
- Console compatibility
- Expanded modding API
- International servers
- Esports competitions

## Conclusion

Hytale adalah game yang menggabungkan best of everything:
- **Building** dari Minecraft
- **Combat** dari action RPGs
- **Adventure** dari open-world games
- **Community** dari multiplayer games

Join **Hytale Indonesia** today dan jadilah bagian dari komunitas gaming terbesar Indonesia! 🇮🇩🎮

**Server IP**: \`play.hytale-id.net\`
**Discord**: discord.gg/z3PFmkCFUP
    `,
  },
  "cara-main": {
    title: "Panduan Bermain",
    content: `
# Panduan Bermain

## Step-by-Step Guide untuk Pemula

Ikuti panduan ini untuk mulai bermain dengan smooth!

### ⏬ Step 1: Download & Install

**Download Game:**
1. Kunjungi [Hytale.com](https://hytale.com)
2. Klik tombol "Download"
3. Pilih OS kamu (Windows/Mac/Linux)
4. Tunggu download selesai (~2-3GB)

**Install:**
1. Run installer
2. Pilih lokasi install (SSD recommended)
3. Ikuti installation wizard
4. Launch game setelah selesai

### 🆔 Step 2: Create Account

**Register:**
1. Buka Hytale launcher
2. Klik "Create Account"
3. Isi information:
   - Username (permanent!)
   - Email address
   - Password (min. 8 characters)
4. Verifikasi email
5. Complete captcha
6. Login dengan credentials

**Profile Setup:**
- Choose avatar/skin
- Set display name
- Configure settings
- Accept EULA

### 🌐 Step 3: Connect ke Server

**Add Server:**
1. Click "Multiplayer"
2. Click "Add Server"
3. Enter details:
   - Name: Hytale Indonesia
   - IP: \`play.hytale-id.net\`
   - Description: (optional)
4. Save server
5. Click "Connect"

**First Connection:**
- Wait for login (15-30s)
- Register: \`/register <password> <password>\`
- Confirm password
- You're in!

### 🎮 Step 4: In-Game Tutorial

**Spawn Area:**
- You start at Spawn Hub
- Follow green NPC markers
- Read information boards
- Complete tutorial untuk rewards

**Claim Starter Kit:**
\`\`\`
/kit starter
\`\`\`
Includes:
- Basic tools
- Food supply
- Building blocks
- Starter money ($1,000)

**Basic Controls:**
- WASD - Movement
- Space - Jump
- Shift - Sneak
- E - Inventory
- Q - Drop item
- F - Interact
- Tab - Player list

### 📍 Step 5: Find a Home

**Random Teleport:**
\`\`\`
/rtp
\`\`\`
Finds safe location in survival world

**Claim Your Land:**
\`\`\`
/claim
\`\`\`
Protects your area dari grief

**Build Your Base:**
- Start dengan small house
- Expand gradually
- Add farms & storage
- Decorate!

### 💡 Tips untuk Sukses

**First Hour:**
1. ✅ Join Discord server
2. ✅ Read /rules
3. ✅ Complete tutorial
4. ✅ Claim starter kit
5. ✅ Find building spot
6. ✅ Set home: \`/sethome\`

**First Day:**
- Gather basic resources
- Build simple shelter
- Farm untuk food
- Explore nearby area
- Say hi di chat!

**First Week:**
- Upgrade tools ke diamond
- Expand base
- Join community events
- Make friends
- Try different game modes

### ❓ Troubleshooting

**Can't Connect:**
- Check IP correct
- Verify internet connection
- Restart game
- Try backup IP: \`server.hytale-id.net\`
- Ask in Discord

**Forgot Password:**
- Contact staff in Discord
- Provide username & email
- Verify identity
- Reset password

**Lost Items:**
- Check \`/back\` untuk death location
- Items stay 5 minutes
- Staff can't return items (policy)
- Use \`/claim\` to prevent loss

**Need Help:**
- \`/helpop <message>\` in-game
- Ask in Discord #support
- Read Wiki / FAQ
- Watch tutorial videos

## Gameplay Basics 🎯

### Survival Tips
**First Night:**
- Build shelter before dark
- Craft bed to skip night
- Light area dengan torches
- Don't wander far

**Resource Gathering:**
- Mine stone → iron → diamond
- Chop trees for wood
- Farm untuk sustainable food
- Fish at rivers/ocean

**Combat:**
- Craft weapons & armor
- Learn enemy patterns
- Use shield to block
- Eat to restore health

### Economy Tips
**Making Money:**
- Mine valuable ores
- Farm & sell crops
- Complete daily quests
- Trade dengan players
- Participate in events

**Spending Wisely:**
- Buy from /shop carefully
- Check /ah for deals
- Save for important upgrades
- Don't waste on cosmetics early

### Social Interaction
**Making Friends:**
- Be friendly in chat
- Help new players
- Join parties
- Trade fairly
- Respect everyone

**Join Community:**
- Discord voice channels
- In-game parties
- Guild/clan systems
- Community events
- Build projects

## Advanced Gameplay 🚀

### Specialization
**Choose Your Path:**

**Builder:**
- Creative mode access
- WorldEdit permissions
- Plot claims
- Build contests

**Fighter:**
- PvP arena access
- Combat skills
- Weapon mastery
- Tournament participation

**Trader:**
- Shop ownership
- Market knowledge
- Auction house expert
- Wealth accumulation

**Explorer:**
- Fast travel unlocks
- Rare discoveries
- Achievement hunter
- Lore collector

### Progression Systems
**Leveling:**
- Kill mobs for XP
- Mine blocks
- Craft items
- Complete quests

**Skills:**
- McMMO skill system
- Specialize in skills
- Unlock abilities
- Max level bonuses

**Reputation:**
- Server reputation points
- Faction standings
- Achievement badges
- Leaderboard ranks

### End-Game Content
**Goals:**
- Max level (100)
- Full diamond/netherite gear
- Own successful shop
- Top leaderboards
- Complete all achievements
- Build epic base
- Win tournaments

## Remember! 💭

> **Play at your own pace!**
> Hytale is about enjoying journey, not rushing to end.

> **Ask for help!**
> Community is friendly - don't be shy!

> **Have fun!**
> That's what games are for! 🎮
    `,
  },
  "sistem-server": {
    title: "Sistem Server",
    content: `
# Sistem Server

Comprehensive guide tentang semua sistem yang ada di server!

## 💰 Economy System

### Currency Types

**Primary Currency:**
- **Coins ($)** - Main in-game currency
  - Earned: Mining, farming, quests, trading
  - Spent: Shop, auctions, services
  - Visible: Scoreboard & \`/balance\`

**Secondary Currency:**
- **Gems (💎)** - Premium currency
  - Earned: Voting, events, donations
  - Spent: Cosmetics, special items, boosts
  - Conversion: 1 Gem = $1,000 coins

**Event Currency:**
- **Tokens (🎫)** - Limited-time currency
  - Earned: Seasonal events only
  - Spent: Event-exclusive rewards
  - Expires: End of event season

### Earning Money 💵

**Mining & Gathering:**
| Resource | Sell Price | Best Location |
|----------|-----------|---------------|
| Coal | $5/block | Y: 5-132 |
| Iron | $25/block | Y: -16-112 |
| Gold | $50/block | Y: -64-32 |
| Diamond | $250/block | Y: -64-16 |
| Emerald | $500/block | Mountains |

**Farming:**
| Crop | Sell Price | Growth Time |
|------|-----------|-------------|
| Wheat | $2/unit | 8 mins |
| Carrot | $3/unit | 10 mins |
| Potato | $3/unit | 10 mins |
| Melon | $8/slice | 15 mins |
| Pumpkin | $10/each | 15 mins |

**Monster Hunting:**
- Zombies: $5-10
- Skeletons: $5-10
- Creepers: $8-12
- Spiders: $6-10
- Bosses: $500-5,000

**Jobs System:**
- \`/jobs\` untuk join (max 2 jobs)
- Passive income saat doing activities
- Level up untuk higher payouts
- Specialization bonuses

### Spending Money 💸

**Server Shop** (\`/shop\`):
- Building materials
- Tools & weapons
- Food & potions
- Special items
- Spawn eggs (limited)

**Player Trading:**
- \`/trade\` - Direct player trade
- \`/ah\` - Auction house marketplace
- \`/shop create\` - Your own shop (VIP+)

**Services:**
- \`/tpa\` - Teleport requests ($50)
- \`/back\` - Return to death spot ($100)
- \`/repair\` - Repair items (varies)
- \`/heal\` - Restore health ($500)

**Upgrades:**
- Claim expansion
- Extra homes
- Kit cooldown reduction
- Special permissions

## 📊 Leveling System

### Experience (XP)

**Sources of XP:**
- 🗡️ **Combat**: 10-100 XP per kill
- ⛏️ **Mining**: 1-10 XP per block
- 🌾 **Farming**: 2-5 XP per harvest
- 🔨 **Crafting**: 5-50 XP per item
- 🎯 **Quests**: 100-10,000 XP per quest
- 🏆 **Events**: 500-5,000 XP per event

**Level Progression:**
- Level 1-10: 1,000 XP per level
- Level 11-25: 2,500 XP per level
- Level 26-50: 5,000 XP per level
- Level 51-75: 10,000 XP per level
- Level 76-100: 25,000 XP per level

**Level Bonuses:**
Every 5 levels:
- +1 max homes
- +5 claim blocks
- +$10,000 bonus
- Unlock new commands
- Special cosmetics

### Stat System

**Allocate Points Each Level:**

**Strength (STR)**
- +2% melee damage per point
- +1% mining speed per 5 points
- Unlock: Heavy weapons at 20 STR

**Dexterity (DEX)**
- +1% attack speed per point
- +0.5% critical chance per point
- Unlock: Dual wielding at 15 DEX

**Constitution (CON)**
- +2 HP per point
- +1% defense per 3 points
- Unlock: Tank abilities at 25 CON

**Intelligence (INT)**
- +2% magic damage per point
- +5 mana per point
- Unlock: Advanced spells at 20 INT

**Luck (LUK)**
- +1% drop rate per point
- +1% crit damage per 2 points
- Unlock: Treasure hunter at 15 LUK

**Reset Stats:** \`/stats reset\` ($50,000 or 50 gems)

### Prestige System

**Max Level 100 → Prestige:**
- Reset to level 1
- Keep all items & money
- +10% XP boost (permanent, stacks)
- Prestige badge & title
- Access to prestige-only areas
- Max prestige: 10

## 🛡️ Protection System

### Land Claiming

**Claim Basics:**
\`\`\`
/claim - Create claim (golden shovel)
/abandonclaim - Delete current claim
/claimlist - List your claims
/claimexpand <amount> - Expand claim
\`\`\`

**Claim Limits:**
| Rank | Max Claims | Claim Blocks |
|------|-----------|--------------|
| Default | 3 | 2,500 |
| Iron | 5 | 5,000 |
| Gold | 8 | 10,000 |
| Diamond | 12 | 20,000 |
| Emerald+ | 20 | 50,000 |

**Earn More Blocks:**
- 100 blocks per hour played
- Vote rewards: 500 blocks
- Purchase with money: $100 per block
- Events: Bonus blocks

**Claim Permissions:**
\`\`\`
/trust <player> - Full access
/accesstrust <player> - Use buttons/levers
/containertrust <player> - Access chests
/permissiontrust <player> - Can manage perms
/untrust <player> - Remove access
\`\`\`

### Anti-Grief System

**Protection Features:**
- ✅ Block break/place protection
- ✅ Chest & container protection  
- ✅ Animal protection
- ✅ Item frame protection
- ✅ Armor stand protection
- ✅ Fire & explosion protection
- ✅ Spawn egg protection

**Grief Detection:**
- Automatic logging system
- CoreProtect rollback
- Staff can restore damage
- Griefers banned + rollback

**Safe Zones:**
- Spawn area (100 block radius)
- Warps & public areas
- PvP disabled
- Build disabled
- Completely safe

## 🎯 Quest System

### Daily Quests

**Reset:** Every 24 hours (00:00 WIB)

**Examples:**
- Mine 100 stone → Reward: $1,000 + 500 XP
- Kill 50 mobs → Reward: $2,000 + 1,000 XP
- Farm 200 crops → Reward: $1,500 + 750 XP
- Catch 25 fish → Reward: $800 + 500 XP
- Trade with 3 players → Reward: $1,200 + 600 XP

**Complete all 5:** Bonus $5,000 + 2,500 XP + 1 Rare Crate Key

### Weekly Quests

**Reset:** Every Monday (00:00 WIB)

**Examples:**
- Mine 1,000 ores → Reward: $15,000 + 10,000 XP
- Build structure 500+ blocks → Reward: $20,000 + 15,000 XP
- Win 10 mini-games → Reward: $25,000 + 20,000 XP
- Complete 25 daily quests → Reward: $30,000 + 25,000 XP

**Complete all:** Bonus $100,000 + 50,000 XP + 1 Legendary Crate Key

### Story Quests

**Main Questline:**
- 50+ story quests
- Unlock new areas
- Exclusive rewards
- Lore & backstory
- Epic boss battles

**Side Quests:**
- Optional content
- Extra rewards
- Character development
- Hidden secrets

**Command:** \`/quests\` untuk open quest menu

## 🏆 Rank System

### Rank Progression

**Default → Ranked:**
Play & earn ranks through:
- Playtime milestones
- Achievement completion
- Quest completion
- Community contribution

**Free Rank Tiers:**
1. **Newcomer** (0-10 hours)
2. **Member** (10-50 hours)
3. **Veteran** (50-200 hours)
4. **Legend** (200-500 hours)
5. **Champion** (500+ hours)

**Donator Ranks:**
Purchase ranks untuk support server:
- Copper → Iron → Silver → Gold
- Thorium → Cobalt → Adamantite
- Mithril → Dragonite → Prisma

Check \`/ranks\` untuk full comparison.

## ⚔️ Combat System

### PvP Zones

**PvP Disabled:**
- Spawn area
- Warps
- Claims (unless allowed)
- Safe zones

**PvP Enabled:**
- Wilderness
- PvP arena
- War zones
- Special events

**Toggle PvP:**
\`\`\`
/pvp - Toggle your PvP status
/pvptoggle - Alternative command
\`\`\`

**Combat Timer:**
- 15 seconds after hitting/being hit
- Cannot teleport during combat
- Cannot use /spawn or /home
- Logging out = death

### Death Mechanics

**Item Loss:**
- **Keep Inventory OFF**: Lose all items
- **Keep Inventory ON** (safe zones): Keep items
- **PvP Death**: Attacker can loot
- **PvE Death**: Items drop, despawn 5 mins

**Death Penalty:**
- Lose 10% current XP (not levels)
- Lose $1,000 (max loss)
- Respawn at spawn or bed

**Recovery:**
\`\`\`
/back - Return to death location ($100)
\`\`\`

## 🎁 Crate System

### Crate Types

**Common Crate** 🟦
- Money: $1,000-5,000
- Basic items
- Common keys
- XP boosters

**Rare Crate** 🟩
- Money: $5,000-15,000
- Rare items & gear
- Enchanted books
- More keys

**Legendary Crate** 🟪
- Money: $15,000-50,000
- Legendary weapons
- Rare cosmetics
- Premium items

**Magical Crate** ✨
- Money: $25,000-100,000
- Magical items
- Exclusive pets
- Special effects

**Survival Crate** 🏆
- Best-in-slot gear
- Permanent upgrades
- Rank vouchers
- Mega rewards

### Getting Keys 🗝️

**Vote Rewards:**
- 1 Common Key per vote site
- 5 votes = 1 Rare Key bonus
- Vote party = Everyone gets key

**Rank Purchase:**
- Bonus keys with every rank
- Higher ranks = better keys

**Events:**
- Win competitions
- Complete challenges
- Random drops
- Staff giveaways

**Shop:**
- Buy with money (expensive!)
- Buy with gems
- Limited availability

### Opening Crates

**Location:**
- Crate area at spawn
- Right-click crate
- Use key from inventory
- Watch animation
- Claim reward!

**Tips:**
- Save legendary keys untuk events (2x rewards)
- Open common crates immediately
- Trade keys dengan players

## 🌐 Server Performance

### Server Specs
- **Host**: High-performance dedicated server
- **Location**: Singapore (optimal untuk Indonesia)
- **CPU**: AMD Ryzen 9 5950X
- **RAM**: 64GB DDR4
- **Storage**: 2TB NVMe SSD
- **Network**: 1Gbps connection
- **DDoS Protection**: Enterprise-level

### Performance Features
- **TPS**: Locked at 20 (always)
- **Tick Rate**: Optimized untuk smooth gameplay
- **View Distance**: 12 chunks (adjustable)
- **Mob Cap**: Balanced untuk performance
- **Auto-Restart**: 3 AM WIB (5 min warning)
- **Backup**: Every 6 hours + manual

### Optimization
- Regular plugin updates
- Performance monitoring
- Resource optimization
- Lag prevention systems
- Entity limiting

## 🔒 Security

### Account Security
- Password encryption
- 2FA available (optional)
- IP logging
- Session management
- Auto-logout (30 min AFK)

### Anti-Cheat
- Advanced detection system
- Automatic bans
- Manual review for edge cases
- Appeal process available

### Data Protection
- Regular backups
- Encrypted storage
- Privacy policy compliance
- No data selling
- GDPR compliant

---

Have questions about server systems?
Ask in-game: \`/helpop\`
Or Discord: #support channel 💚
    `,
  },
  faq: {
    title: "FAQ - Frequently Asked Questions",
    content: `
# FAQ - Frequently Asked Questions

Jawaban untuk pertanyaan yang sering ditanyakan!

## 🎮 General

### Q: Apakah server ini gratis?
**A:** Ya! Server 100% gratis untuk dimainkan. Rank adalah donation optional untuk support server development dan mendapatkan perks tambahan.

### Q: Jam berapa server online?
**A:** Server online **24/7** dengan uptime 99.9%. Maintenance jarang (max 1 jam) dan diumumkan sebelumnya.

### Q: Berapa banyak player online?
**A:** Average 100-300 players online. Peak time (sore-malam WIB) bisa mencapai 500+ players.

### Q: Apakah crossplay supported?
**A:** Saat ini Hytale official hanya di PC. Mobile/Console masih dalam development.

### Q: Bahasa apa yang digunakan?
**A:** Bahasa Indonesia sebagai main language. English speakers welcome tapi prioritas Indonesia.

### Q: Umur minimal untuk main?
**A:** No age restriction, tapi recommended 13+ tahun. Younger players harus supervised.

## 🔧 Technical

### Q: Tidak bisa connect ke server?
**A:** Troubleshooting steps:
1. ✅ Verify IP correct: \`play.hytale-id.net\`
2. ✅ Check internet connection stable
3. ✅ Restart Hytale launcher
4. ✅ Try backup IP: \`server.hytale-id.net\`
5. ✅ Check firewall settings
6. ✅ Disable VPN if using
7. ✅ Join Discord untuk support

### Q: Game crash saat join server?
**A:** Possible solutions:
- Update Hytale to latest version
- Update graphics drivers
- Allocate more RAM (8GB recommended)
- Lower graphics settings
- Reinstall game
- Report crash log di Discord

### Q: Lag/High ping saat bermain?
**A:** Reduce lag dengan:
- **Graphics**: Lower render distance (8-12 chunks)
- **Network**: Use wired connection instead of WiFi
- **Background**: Close other apps/downloads
- **VPN**: Disable jika tidak perlu
- **Location**: Server hosted di Singapore (optimal untuk Indonesia)

Expected ping:
- Indonesia: 20-50ms (excellent)
- Malaysia/Singapore: 10-30ms (perfect)
- Other SEA: 50-100ms (playable)

### Q: Data/items saya hilang!
**A:** Report immediately:
1. Don't panic - server backup every 6 hours
2. Screenshot evidence jika ada
3. \`/ticket create\` in-game ATAU
4. Open ticket di Discord #support
5. Staff akan investigate & restore jika valid

**Note:** Staff TIDAK bisa restore items yang:
- Dropped intentionally
- Lost karena PvP death
- Given away to other players
- Scammed (trade at your own risk)

### Q: Lupa password server!
**A:** Password reset process:
1. Join Discord server
2. Open ticket di #support
3. Provide: username, email, last login
4. Staff verify identity
5. Password direset (biasanya < 1 jam)

**Prevention:** Write password somewhere safe!

## 💰 Economy & Trading

### Q: Bagaimana cara dapat uang?
**A:** Multiple ways:
- ⛏️ **Mining** - Sell ores di \`/shop\`
- 🌾 **Farming** - Grow & sell crops
- 🗡️ **Monster Hunting** - Mob drops coins
- 📦 **Trading** - Buy low, sell high di \`/ah\`
- 🎯 **Quests** - Daily & weekly quests
- 💼 **Jobs** - \`/jobs\` untuk passive income
- 🎁 **Events** - Win prizes
- 🏆 **Achievements** - Reward money

### Q: Apa itu Auction House?
**A:** Player marketplace:
- \`/ah\` untuk open
- List items untuk sell
- Browse & buy dari players
- 5% tax per sale
- 48 hour listing duration

Tips:
- Check prices before listing
- Undercut slightly untuk fast sell
- Rare items sell better
- Timing matters (weekend = more buyers)

### Q: Apakah trading aman?
**A:** Trading system:
✅ **Safe:** \`/trade\` command - protected
❌ **Unsafe:** Drop trading - bisa scam
❌ **Prohibited:** Real money trading (RMT)

Anti-scam tips:
- Gunakan \`/trade\` command only
- Double-check items before accept
- Screenshot trade untuk proof
- Report scammers immediately
- If deal too good to be true, it probably is

### Q: Bisa trade/jual rank saya?
**A:** ❌ **NO**. Rank trading/selling **prohibited**:
- Ranks are account-bound
- Cannot transfer to other players
- Selling for real money = ban
- Trading for in-game items = ban

## 🏆 Ranks & Donations

### Q: Bagaimana cara beli rank?
**A:** Purchase process:
1. Join Discord server
2. Check \`#store-info\` untuk prices & benefits
3. Open ticket di \`#purchase-ticket\`
4. Pilih rank yang diinginkan
5. Follow staff instructions untuk payment
6. Payment methods: GoPay, OVO, Dana, Transfer Bank
7. Rank activated within 5-30 minutes setelah payment confirmed

### Q: Rank bisa expired?
**A:** ❌ **NO**. All ranks are **PERMANENT**:
- One-time payment
- No monthly subscription
- Keep forever
- Benefits permanent
- Can upgrade to higher rank (pay difference only)

### Q: Apa bedanya setiap rank?
**A:** Key differences:
- 💵 **Bonus Money** - Startup capital
- 🗝️ **Keys** - Crate keys
- 🏠 **Homes** - More /home slots
- 📦 **Auction Slots** - List more items
- ⚙️ **Commands** - Special commands
- 🎨 **Cosmetics** - Prefix, colors, effects
- ⏱️ **Cooldowns** - Reduced wait times

Check \`/ranks\` atau website untuk full comparison.

### Q: Bisa refund setelah beli?
**A:** **Limited refund policy**:
✅ Refund dalam 24 jam jika:
- Technical error (didn't receive rank)
- Accidental double purchase
- Server permanently shutdown (pro-rated)

❌ NO refund jika:
- Changed your mind
- Banned for rule violation
- Ragequit server
- Found better server

### Q: Cara upgrade rank?
**A:** Upgrade process:
- Pay **ONLY the difference** between ranks
- Example: Iron (50k) → Silver (75k) = pay 25k
- Keep all previous benefits
- Can skip ranks (Iron → Gold directly)
- Contact staff via Discord ticket

## 🎯 Gameplay

### Q: Gimana cara claim land?
**A:** Land protection:
\`\`\`
/claim - Auto-claim area saat ini
/trust <player> - Give access to friend
/abandonclaim - Delete claim
\`\`\`

**Claim sizes:**
- Default: 2,500 blocks
- Expand with ranks
- Earn more dengan playtime
- Max claim: 25,000 blocks

**Protection:**
- No griefing in claims
- No PvP in claims (unless toggled)
- No explosion damage
- Chest protection automatic

### Q: Bagaimana sistem PvP?
**A:** PvP mechanics:
- **Spawn/Safe Zones**: PvP OFF
- **Wilderness**: PvP ON (dapat di-toggle)
- **Claims**: PvP OFF (owner can enable)
- **PvP Arena**: Always ON
- **War Events**: Special rules

Commands:
- \`/pvp\` - Toggle your PvP status
- \`/duel <player>\` - Friendly duel
- \`/arena\` - Join PvP arena

Keep items on death dalam safe PvP (duels).
Lose items on death di wilderness PvP.

### Q: Ada mini-games apa saja?
**A:** Available mini-games:
- 🛏️ **Bedwars** - Protect bed, destroy others
- ☁️ **Skywars** - Sky islands battle royale
- 🏗️ **Build Battle** - Timed building contest
- 🙈 **Hide & Seek** - Classic hide and seek
- 🏃 **Parkour** - Jumping challenges
- 🚩 **Capture the Flag** - Team-based CTF
- ⚔️ **Duels** - 1v1 PvP matches

Access: \`/games\` atau NPC di spawn

### Q: Sistem crates gimana?
**A:** Crate rewards:
**Types:**
- Common Crate
- Rare Crate
- Legendary Crate
- Magical Crate
- Survival Crate

**Get Keys:**
- Vote rewards
- Rank purchase bonus
- Event wins
- Donation milestones
- Sometimes in \`/shop\`

**Contents:**
- Rare items & weapons
- Money & keys (more crates!)
- Cosmetics & pets
- Rank upgrades
- Special effects

### Q: Jobs system explained?
**A:** Job system:
**Available Jobs:**
- Miner - Paid untuk mining
- Woodcutter - Paid untuk chopping
- Farmer - Paid untuk farming
- Hunter - Paid untuk killing mobs
- Builder - Paid untuk placing blocks
- Fisherman - Paid untuk fishing

**How it Works:**
- \`/jobs\` untuk join (max 2 jobs)
- Level up dengan doing job actions
- Higher level = more payment
- Unlock bonuses at milestones
- Can switch jobs (keep progress)

## 🛡️ Rules & Moderation

### Q: Bagaimana cara report player?
**A:** Reporting system:
**In-game:**
\`\`\`
/report <player> <reason>
\`\`\`

**Discord:**
1. Open ticket di #report-player
2. Provide: username, offense, proof
3. Screenshots/videos very helpful
4. Staff review dan take action

**Response time:** 5-60 minutes depending on severity.

### Q: Berapa lama ban duration?
**A:** Punishment scale:

- **Warning 1**: Chat warning
- **Warning 2**: 1 hour mute
- **Warning 3**: 24 hour mute
- **Warning 4**: 7 day temp ban
- **Warning 5+**: Permanent ban

**Serious offenses** (hacking, severe harassment):
- Immediate permanent ban
- No warnings
- IP ban jika necessary

### Q: Bisa appeal ban?
**A:** Ban appeal process:
1. Wait **minimum 30 days** after ban
2. Go to Discord
3. Read #ban-appeal-format
4. Submit appeal dengan format
5. Be honest & apologetic
6. Staff review (1-7 days)

**Approval chance:**
- First offense: High (~70%)
- Second offense: Medium (~30%)
- Third+: Very low (<10%)
- Hacking: Very low
- Harassment: Low

### Q: Staff abuse, gimana?
**A:** Report staff misconduct:
1. **NEVER report public** - DM owner directly
2. Provide evidence:
   - Screenshots
   - Chat logs
   - Video if possible
3. Explain situation clearly
4. Owner investigates privately
5. Action taken if confirmed

**False reports** will result in punishment!

## 🤝 Community

### Q: Cara join Discord?
**A:** Discord server:
- Link: **discord.gg/z3PFmkCFUP**
- Verify untuk get roles
- Read #rules channel
- Introduce yourself di #introductions
- Ask questions di #support
- Have fun!

Benefits:
- Announcements & updates
- Support dari staff & community
- LFG untuk parties
- Event notifications
- Voice channels
- Bot commands
- Giveaways

### Q: Bisa buat guild/clan?
**A:** Kami menggunakan sistem **Fraksi** dengan SimpleClaims:

**Cara Membuat Fraksi:**
1. Buat Claims dulu dengan \`/sc\`
2. Pilih Mode: \`/sc mode Aggressor\` atau \`/sc mode Pacifist\`

**SimpleClaims - Raid Base System:**

Server memiliki fitur **Raid Base** dengan 2 mode:

🕊️ **Pacifist Mode**
- Party netral yang tidak bisa diserang atau menyerang
- Fokus untuk building dan ekonomi

⚔️ **Aggressor Mode**
- Bisa mengajukan Raid/PvP untuk claim territory lawan
- Saat Raid: kedua party bisa PVP, break blocks, place blocks, dan interact chest di zona lawan
- Territory yang kalah akan diambil pemenang setelah **3x Raid menang**

**Raid Mechanics:**
- ✅ Sistem Accept/Decline - kamu bisa pilih terima atau tolak raid
- ✅ Raid Surrender - bisa menyerah kapan saja
- ✅ Win Condition: bunuh semua member party lawan yang **online** (offline tidak terhitung)
- ✅ Cooldown: 30 minutes setelah raid selesai untuk persiapan strategy

**Command List:**
- \`/sc\` - Claim territory
- \`/scp\` - Buka menu party
- \`/sc mode <Aggressor/Pacifist>\` - Pilih mode party
- \`/sc help\` - Help & info lengkap

---

## 📋 Command List Lengkap

### 💰 Economy
- \`/bal\` (\`/balance\`, \`/cash\`) - Check uang dari job
- \`/pay <user> <jumlah>\` - Transfer cash ke player lain
- \`/shop\` - Buka in-game shop UI
- \`/kits\` - Menu kits & claim kits
- \`/job\` - Menu pekerjaan

### 🌍 Teleport
- \`/rtp\` - Random teleport
- \`/back\` - Teleport ke tempat terakhir mati (GOLD RANK+)
- \`/tpa <user>\` - Request teleport ke player lain
- \`/tphere <user>\` - Request player teleport ke kamu
- \`/tpaccept\` - Terima request teleport
- \`/tpdeny\` - Tolak request teleport

### 🏠 Home Access
- \`/sethome\` - Set home spawn point
- \`/home\` - List & teleport ke home
- \`/delhome <name>\` - Hapus home dari list

### ⚔️ Party System
- \`/p create\` - Buat party
- \`/p rename\` - Ganti nama party (Leader only)
- \`/p chat\` - Toggle party chat
- \`/p invite <user>\` - Invite player
- \`/p accept\` - Terima invite party
- \`/p decline\` - Tolak invite party
- \`/p leave\` - Keluar dari party
- \`/p kick <user>\` - Kick player (Leader only)
- \`/p tp <user>\` - Teleport ke anggota party

### 🎯 Miscellaneous
- \`/mmoxp\` - Skill tree untuk bonus buff
- \`/msg <user> <pesan>\` - Private message
- \`/msgtoggle\` - Toggle private chat on/off
- \`/sc\` - Claim territory
- \`/scp\` - Menu party SimpleClaims

### Q: Gimana cara breeding hewan?
**A:** Breeding Tutorial:

**Step-by-Step:**
1. 🐄 Deketin 2 hewan dewasa (same species)
2. 🌾 Kasih makan kedua hewan tersebut dengan makanan yang sesuai
3. 💕 Tunggu mereka saling mendekat
4. 🐣 Anak brojol instan!

**Daftar Hewan & Makanannya:**

- 🐄 **Cow** - Cauliflower (atau Wheat, Lettuce)
- 🐷 **Pig** - Brown Mushroom (atau Carrot, Potato, Apple)
- 🐔 **Chicken** - Corn (atau Wheat, Rice)
- 🐑 **Sheep** - Lettuce (atau Wheat, Cauliflower)
- 🐐 **Goat** - Apple (atau Wheat, Carrot)
- 🐴 **Horse** - Carrot (atau Apple, Wheat)
- 🐫 **Camel** - Wheat (atau Cactus Fruit)
- 🐏 **Ram** - Apple (atau Wheat)
- 🦃 **Turkey** - Corn (atau Wheat)
- 🐗 **Boar** - Red Mushroom (atau Brown Mushroom, Apple)
- 🐰 **Rabbit** - Carrot (atau Lettuce, Apple)
- 🦬 **Bison** - Wheat (atau Corn)

**Tips:**
- Makanan pertama adalah yang paling recommended
- Alternatif makanan dalam kurung juga work
- Cooldown breeding: tunggu beberapa menit sebelum breeding lagi

### Q: Ada program Content Creator?
**A:** Kami dengan bangga memperkenalkan **Rank Content Creator** di Hytale Indonesia Community (HIC)!

Rank ini ditujukan bagi para kreator yang aktif membuat dan membagikan konten mengenai HIC sebagai bentuk dukungan terhadap perkembangan komunitas.

**📝 Syarat & Ketentuan:**

**Tier 1 (2.000+ followers):**
- ✅ Minimal **2.000 followers** (TikTok/YouTube/Instagram)
- ✅ Upload konten tentang HIC **2x setiap bulan**
- ✅ Konten dapat menggunakan materi dari HIC
- ✅ Wajib follow TikTok HIC

**Tier 2 (<2.000 followers):**
- ✅ Followers di bawah 2.000 tetap bisa apply!
- ✅ Upload konten HIC **4x setiap bulan**
- ✅ 2x pakai materi HIC + 2x konten mandiri

**🎁 Benefits:**
- 🎨 Role Discord khusus **Content Creator**
- 👑 Rank eksklusif **Content Creator** in-game
- 🔗 Sharelink khusus Content Creator (HIC)
- 🗝️ **1 Legendary Key** per konten dengan minimal 5.000 views

**⚠️ Ketentuan Tambahan:**
- Benefit dapat dicabut jika tidak memenuhi ketentuan
- Konsistensi upload wajib dijaga
- Konten harus sesuai dengan rules server (family-friendly)

**📩 Cara Apply:**
Contact Admin atau Staff di Discord untuk informasi lebih lanjut dan pendaftaran!

## 📱 Contact & Support

### Q: Cara contact staff?
**A:** Multiple channels:

**Urgent (in-game):**
- \`/helpop <message>\` - Alert online staff
- Response: Usually < 5 minutes

**Non-Urgent:**
- \`/ticket create\` - Support ticket system
- Discord #support channel
- Response: 15 minutes - 2 hours

**Bug Reports:**
- Discord #bug-reports
- Include: description, steps, screenshots
- Severity level (critical/major/minor)

**Suggestions:**
- Discord #suggestions
- Community votes on ideas
- Popular suggestions implemented

### Q: Bahasa lain selain Indonesia?
**A:** Language support:
- 🇮🇩 **Indonesia**: Full support (primary)
- 🇬🇧 **English**: Partial support
- Other: Community translation help

Chat channels:
- \`/g\` - Global (Indonesia)
- \`/trade\` - Trade (Indonesia/English mix)
- \`/english\` - English chat channel

## 🔜 Future & Updates

### Q: Update frequency?
**A:** Update schedule:
- **Bug Fixes**: ASAP (< 24 hours)
- **Minor Updates**: Weekly (Fridays)
- **Major Updates**: Monthly
- **Seasonal Events**: Special occasions

Follow Discord #announcements untuk stay updated!

### Q: Ada planned features?
**A:** Upcoming features:
- ✅ Custom mobs & bosses
- ✅ More mini-games
- ✅ Pets & companions
- ✅ Cosmetic system expansion
- ✅ Guild territories
- ✅ Seasonal ranks
- ✅ Mobile app (companion)
- ✅ Tournament system

Vote for features di Discord #suggestions!

### Q: Roadmap untuk 2026?
**A:** 2026 Goals:
- Q1: Stabilization & optimization
- Q2: Major content update (new zones)
- Q3: Competitive scene development
- Q4: End-year mega event

Long-term vision:
- Largest Indonesian Hytale community
- International recognition
- Esports tournaments
- Creator ecosystem

---

## Still Have Questions? 🤔

**Ask us!**
- 💬 In-game: \`/helpop\`
- 💬 Discord: #support channel
- 💬 Website: Contact form

**We're here to help!** 😊🎮

No question is stupid - kita semua pernah pemula!
    `,
  },
  rules: {
    title: "Server Rules",
    content: `
# Server Rules 📜

Dengan bermain di server kami, kamu otomatis setuju untuk mengikuti peraturan berikut. Mari jaga server tetap nyaman untuk semua! 🎮

---

### 1. 🤝 Hormati Petualang Lain

**No SARA | No Toxic | No Drama**

Gunakan bahasa yang sopan, hormati perbedaan, dan jaga suasana tetap positif untuk semua petualang.

---

### 2. 🔞 Konten Semua Umur

**Family-Friendly Server**

Dilarang keras konten NSFW, Gore, atau hal tidak pantas. Keep it clean untuk semua umur!

---

### 3. 💬 Gunakan Channel Sesuai Jalur

**Right Place, Right Topic**

Chat hanya di channel yang sudah disediakan fungsinya. Trading di #trading, support di #support.

---

### 4. 🚫 Dilarang Spam

**Keep it Clean**

Dilarang spam chat, spam emoji, atau spam mention (@everyone). Give others chance to speak!

---

### 5. 🛡️ Anti Sihir Hitam (Security)

**Stay Safe, Stay Secure**

Dilarang menyebar link phising, scam, atau malware. Report suspicious activity ke staff!

---

### 6. 🌐 Penyebaran Server

**Respect Our Community**

Dilarang menyebarkan server orang lain tanpa persetujuan Admin.

---

### 7. 💰 Izin Dagang & Promosi

**Safe Trading Environment**

Dipersilahkan RMT, namun lewat Admin sebagai Midman demi kenyamanan bersama.

**Cara RMT Aman:**
1. Contact Admin untuk jadi middleman
2. Admin akan facilitate transaction
3. Both parties protected dari scam

---

### 8. 👑 Sabda Tetua (Authority)

**Final Decision**

Keputusan Moderator & Admin adalah mutlak. Appeals bisa dilakukan melalui ticket system.

---

## ⚠️ Sistem Hukuman

**Sanksi Bertingkat:**

**🟡 Warning** → **🟠 Mute (1-24 jam)** → **🔴 Kick** → **⚫ Temp Ban (7-30 hari)** → **💀 Permanent Ban**

Staff berhak memberikan hukuman langsung untuk pelanggaran berat atau skip warning levels untuk kasus serius.

---

## 📢 Catatan Penting

Jika ada pertanyaan tentang rules, tanya di #support atau create ticket.

**Remember**: Ignorance of rules bukan excuse! Baca dan pahami sebelum bermain.

---

💚 **Terima kasih sudah mematuhi rules dan menjaga server Hytale Indonesia tetap awesome!**
    `,
  },
};
